import { useState } from "react";
import Header from "../Header";

const WatiGreetings = () => {
    const [formData, setFormData] = useState({
        text: ''
    });
    const role = localStorage.getItem('role');
    const id = localStorage.getItem('userId');
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value }); // Fixed state update
    };   

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            role: role,
            mgr_id: id
        };
        try {
            const response = await fetch("https://apiaksharaconnect.aksharafinalytics.in/WAGreetings", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            console.log("Response: ", data);
            
            setSuccessMessage("Message Sent Successfully");
            setFormData({ text: '' });
        } catch (error) {
            //console.error("Error submitting form: ", error);
            setSuccessMessage('Somthing went worng, please Try agin');
        }
    };

    return (
        <>
            <Header />
            <div className="container mt-5">
            {successMessage && <div className="alert alert-success text-center">{successMessage}</div>}
                <div className="card shadow">
                    
                    <div className="card-header">
                        <h2>Greetings Wati</h2>
                    </div>
                    
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <input type="hidden" name="role" value={role}/>
                            <input type="hidden" name="mgr_id" value={id}/>
                            <div className="mb-3">
                                <label className="form-label">Greetings</label>
                                 <textarea className="form-control"  name="text" value={formData.text} onChange={handleChange} rows="4" required/>
                            </div>
                            <center>
                                <button type="submit" className="btn btn-primary">
                                    Send Message
                                </button>
                            </center>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WatiGreetings;
